import { render, staticRenderFns } from "./ConfirmationPassword.vue?vue&type=template&id=606bcd21&"
import script from "./ConfirmationPassword.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports